export default __webpack_public_path__ + "static/media/arrow_right.61fa4427.svg";